export default __webpack_public_path__ + "static/media/skyvssea-customization-page.238981fd.png";